import {
  FETCH_INITIAL_STATE,
  LOGIN,
  LOGOUT,
  RECEIVE_INITIAL_STATE,
} from "@/components/access/ducks/Actions"

const defaultState = {
  loggedIn: false,
}

const userAccessReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case LOGIN:
      return {
        ...oldState,
        loggedIn: true,
      }

    case FETCH_INITIAL_STATE:
      return {
        ...oldState,
        fetchingState: true,
      }

    case RECEIVE_INITIAL_STATE: {
      return {
        ...oldState,
        fetchingState: false,
      }
    }

    default:
      return oldState
  }
}

export default userAccessReducer
